module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gender-selector",
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "button-container"
  }, [_c('div', [_c('b-button', {
    staticClass: "btn-block select-gender-male",
    attrs: {
      "variant": _vm.selected.indexOf("m") === -1 ? "inactive" : "target"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.toggle("m")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('terms.gender.male')))])], 1), _c('div', [_c('b-button', {
    staticClass: "btn-block select-gender-female",
    attrs: {
      "variant": _vm.selected.indexOf("f") === -1 ? "inactive" : "target"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.toggle("f")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('terms.gender.female')))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3f17b5c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/gender-selector/GenderSelector.vue
// module id = 968
// module chunks = 1